import React, { ReactNode } from "react";

interface TooltipProps {
  label: string;
  show: boolean;
  children: ReactNode;
  alignRight?: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({
  label,
  show,
  children,
  alignRight,
}) => {
  return (
    <div className="flex relative">
      {children}

      {/* Tooltip */}
      {show && (
        <div
          className={`flex max-w-64 m-1 py-2 px-3 absolute top-full ${alignRight ? "left-full" : "left-1/2"} transform -translate-x-1/2 bg-gray-700 text-sm rounded whitespace-normal pointer-events-none`}
          style={{ zIndex: 9999 }}
        >
          <div className="w-max text-xs text-white">{label}</div>
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 -mb-1">
            <div className="border-4 border-transparent border-b-white"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export { Tooltip };
